import React, { FC } from "react";
import { Text, View } from "react-native";
import { Style, StyleArray, styles } from "../../theme/styles";
import { useTheme } from "../../theme/colors";
import { Button, Gap } from "../../components";
import { ButtonType, IsMobile } from "../../theme";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { AuthStackParams } from "../../navigation/Auth/AuthStackParams";
import { LoginRoute, SignupRoute } from "../../navigation/Auth/routes";
import OneSpaceLogo from "../../Icons/OneSpaceLogo";
import * as Application from "expo-application";

const appVersion = Application.nativeApplicationVersion || "1.0.0"; // Fallback for safety


const GettingStarted: FC = () => {
    const navigation = useNavigation<NavigationProp<AuthStackParams>>();
    const theme = useTheme();

    return (
      <View
        style={[
            $container,
            { backgroundColor: theme.BACKGROUND, padding: 20 },
        ]}
      >
          {/* Content Wrapper */}
          <View style={{ flex: 1, justifyContent: "space-between", alignItems: "center" }}>
              <View style={{ alignItems: "center" }}>
                  <OneSpaceLogo width={300} height={200} />
                  <View style={$body}>
                      <View style={[IsMobile ? {} : { width: 300 }]}>
                          <Text style={{ ...$teaser, color: theme.TEXT }}>
                              The place to improve your wellbeing.
                          </Text>
                      </View>
                  </View>
                  <Gap gap={80} />
                  <View style={{ gap: 20 }}>
                      <Button
                        color={theme.TEXT}
                        title="Register"
                        onPress={() => navigation.navigate(SignupRoute, {})}
                      />
                      <Button
                        variant={ButtonType.secondary}
                        title="Login"
                        onPress={() => navigation.navigate(LoginRoute)}
                      />
                  </View>
              </View>

              <Text style={{ color: theme.TEXT, fontSize: 14, marginBottom: 20 }}>
                  Version {appVersion}
              </Text>
          </View>
      </View>
    );
};

export default GettingStarted;

const $container: StyleArray = [styles.flex1, styles.center];

const $text: Style = {
    ...styles.textCenter,
    fontWeight: "500",
};

const $teaser: Style = {
    ...styles.textCenter,
    fontWeight: "600",
};

const $body: Style = {
    ...styles.center,
    marginTop: 40,
};